import { render, staticRenderFns } from "./ProjectRealEstatesSelector.vue?vue&type=template&id=0e696652&scoped=true"
import script from "./ProjectRealEstatesSelector.vue?vue&type=script&lang=ts"
export * from "./ProjectRealEstatesSelector.vue?vue&type=script&lang=ts"
import style0 from "./ProjectRealEstatesSelector.vue?vue&type=style&index=0&id=0e696652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e696652",
  null
  
)

export default component.exports